import Storage from "./Storage";
import { CompanyFeatures } from "../common/types";

const STORAGE_KEY = "companyFeatures";

// The features column can come back as a JSON string or an already-parsed
// object depending on how the backend serializes it — handle both.
export const parseCompanyFeatures = (raw: unknown): CompanyFeatures => {
  if (!raw) return {};
  if (typeof raw === "string") {
    try {
      return JSON.parse(raw) as CompanyFeatures;
    } catch {
      return {};
    }
  }
  return raw as CompanyFeatures;
};

export const cacheCompanyFeatures = (raw: unknown): void => {
  Storage.set(STORAGE_KEY, JSON.stringify(parseCompanyFeatures(raw)));
};

export const getCachedCompanyFeatures = (): CompanyFeatures => {
  try {
    return JSON.parse(Storage.get(STORAGE_KEY) || "{}") as CompanyFeatures;
  } catch {
    return {};
  }
};

// Helper used to decide whether a part of the UI should be visible for the
// logged-in user's company, e.g. isCompanyFeatureEnabled("is_nanny_enabled").
export const isCompanyFeatureEnabled = (key: string): boolean => {
  return !!getCachedCompanyFeatures()[key];
};
